import React, { createElement, Component } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
const SHARE_TITLE = 'Talab — Your AI Storefront. The Future Marketplace.';
const SHARE_DESCRIPTION = 'From browsing and filters to simply asking. See how Talab turns any business into an AI storefront — and how those storefronts become the Talab Marketplace.';
const SHARE_IMAGE = 'https://cdn.magicpatterns.com/patterns/generated-images/04036775-e4b6-4d68-8bf8-a1a0b8dfdb74.jpg';
const TALAB_LOGO = 'https://cdn.magicpatterns.com/uploads/4YWxpYRVWvWhebcgYXkofj/ChatGPT_Image_Jun_14,_2026,_06_55_09_PM.png';

// Browser tab title
document.title = SHARE_TITLE;

/** Favicon: the Talab mark, with a brand-gradient "T" as the fallback. */
const faviconSvg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
  <defs>
    <linearGradient id="g" x1="0" y1="0" x2="1" y2="1">
      <stop offset="0%" stop-color="#4338CA"/>
      <stop offset="100%" stop-color="#A855F7"/>
    </linearGradient>
  </defs>
  <rect width="64" height="64" rx="16" fill="url(#g)"/>
  <text x="32" y="45" font-family="Plus Jakarta Sans, Inter, sans-serif" font-size="38" font-weight="800" fill="#ffffff" text-anchor="middle">T</text>
</svg>`;
const setLink = (rel: string, href: string, type?: string) => {
  document.querySelectorAll(`link[rel='${rel}']`).forEach(el => el.parentNode?.removeChild(el));
  const link = document.createElement('link');
  link.rel = rel;
  link.href = href;
  if (type) link.type = type;
  document.head.appendChild(link);
};
const setFavicon = () => {
  document.querySelectorAll("link[rel='shortcut icon']").forEach(el => el.parentNode?.removeChild(el));
  setLink('icon', `data:image/svg+xml,${encodeURIComponent(faviconSvg)}`, 'image/svg+xml');
  setLink('apple-touch-icon', TALAB_LOGO);
};
setFavicon();

/** Social / link-preview metadata (WhatsApp, Slack, LinkedIn, X, iMessage). */
const setMeta = (key: 'name' | 'property', value: string, content: string) => {
  let meta = document.querySelector(`meta[${key}='${value}']`) as HTMLMetaElement | null;
  if (!meta) {
    meta = document.createElement('meta');
    meta.setAttribute(key, value);
    document.head.appendChild(meta);
  }
  meta.content = content;
};
const setShareMeta = () => {
  setMeta('name', 'description', SHARE_DESCRIPTION);
  setMeta('name', 'theme-color', '#0B1220');
  setMeta('name', 'application-name', 'Talab');
  setMeta('property', 'og:type', 'website');
  setMeta('property', 'og:site_name', 'Talab');
  setMeta('property', 'og:title', SHARE_TITLE);
  setMeta('property', 'og:description', SHARE_DESCRIPTION);
  setMeta('property', 'og:image', SHARE_IMAGE);
  setMeta('property', 'og:image:width', '1376');
  setMeta('property', 'og:image:height', '768');
  setMeta('property', 'og:image:alt', 'Talab — Your AI Storefront. The Future Marketplace.');
  setMeta('property', 'og:url', window.location.origin);
  setMeta('name', 'twitter:card', 'summary_large_image');
  setMeta('name', 'twitter:title', SHARE_TITLE);
  setMeta('name', 'twitter:description', SHARE_DESCRIPTION);
  setMeta('name', 'twitter:image', SHARE_IMAGE);
};
setShareMeta();

// Without this, mobile browsers lay the page out at a ~980px desktop width and
// nothing responsive ever engages — the deck and app only adapt on a laptop.
const setViewportMeta = () => {
  const content = 'width=device-width, initial-scale=1, viewport-fit=cover';
  let meta = document.querySelector("meta[name='viewport']") as HTMLMetaElement | null;
  if (!meta) {
    meta = document.createElement('meta');
    meta.name = 'viewport';
    document.head.appendChild(meta);
  }
  if (meta.content !== content) meta.content = content;
};
setViewportMeta();
render(<App data-id="element-3303" data-mp="3kcbqmb0qqwq4" />, document.getElementById('root'));